import { cardsTopupForOperations, cardsTypeEmitterForOperations, cardsTypeForOperations, cardsProductForOperations } from '@/assets/scripts/mappers/cards'
import { cardNumberMaskedFormat } from '@/assets/scripts/strings'
import { amountFormat } from '@/assets/scripts/amounts'
import { getMonthYear } from '@/assets/scripts/dateBuilders'
import { ACCOUNT_NUMBER } from '@/assets/constants/masks'
import { routeList } from '@/router/helpers/routes'
import { useI18n } from 'vue-i18n'

/* Filters cards for a specific feature
@cardsList { array } - list of cards
@returns { array } - returns cards available for this route feature
*/
export const parseCardsForFeature = (cardsList) => {
	const currentRoutePath = window.location.hash.replace('#', '').split('?')[0]
	const routePathKey = Object.keys(routeList).find(key => routeList[key] === currentRoutePath)
	const mapperRoute = routePathKey.replace('_PATH', '')

	/* We first checking if there's no accounts, if not, we simply return the empty array we just received */
	if (!cardsList.length) return cardsList

	let allCards = cardsList

	/* Validate if there's a filter by topupMode for this operation, if so we filter the array */
	if (cardsTopupForOperations[mapperRoute]) {
		const allowedTopupModes = cardsTopupForOperations[mapperRoute]
		allCards = allCards.filter(card => { return allowedTopupModes.find(topupMode => { return topupMode === card.topupMode }) })
		allCards = allCards.filter(card => { return card.allowsTopup })
	}

	/* Validate if there's a filter by typeEmitter for this operation, if so we filter the array */
	if (cardsTypeEmitterForOperations[mapperRoute]) {
		const allowedTypesEmitter = cardsTypeEmitterForOperations[mapperRoute]
		allCards = allCards.filter(cards => { return allowedTypesEmitter.find(typeEmitter => { return typeEmitter === cards.typeEmitter }) })
	}

	/* Validate if there's a filter by type for this operation, if so we filter the array */
	if (cardsTypeForOperations[mapperRoute]) {
		const allowedTypes = cardsTypeForOperations[mapperRoute]
		allCards = allCards.filter(cards => { return allowedTypes.find(type => { return type === cards.type }) })
	}

	/* Validate if there's a filter by product for this operation, if so we filter the array */
	if (cardsProductForOperations[mapperRoute]) {
		const allowedProducts = cardsProductForOperations[mapperRoute]
		allCards = allCards.filter(cards => { return allowedProducts.find(product => { return product === cards.product }) })
	}

	/* More specific filter based on route feature */
	if (mapperRoute === 'CARDS_BLOCK') allCards = allCards.filter(card => { return card.blockable || card.unblockable })
	// if (mapperRoute === 'CARDS_LIMITS') allCards = allCards.filter(card => { return card.blockable })
	if (mapperRoute === 'CARDS_CANCEL') allCards = allCards.filter(card => { return card.cancelable })

	return allCards
}

export const commonCardDetailParser = (card) => {
	const { t } = useI18n()

	return [{
		label: t('cards.commonDetail.balance'),
		content: !card.balance && card.balance !== 0 ? '-' : (card.balance === 0 ? '-' : amountFormat(card.balance, card.currency))
	}, {
		label: t('cards.commonDetail.accountingBalance'),
		content: !card.accountingBalance && card.accountingBalance !== 0 ? '-' : (card.accountingBalance === 0 ? '-' : amountFormat(card.accountingBalance, card.currency))
	}, {
		label: t('cards.commonDetail.account'),
		content: card.accountNumber,
		mask: ACCOUNT_NUMBER
	}, {
		label: t('cards.commonDetail.name'),
		content: card.name
	}, {
		label: t('cards.commonDetail.cardNumber'),
		content: cardNumberMaskedFormat(card.cardNumber)
	}, {
		label: t('cards.commonDetail.description'),
		content: card.additionalInfoCardView && card.additionalInfoCardView.friendlyName ? card.additionalInfoCardView.friendlyName : '-'
	}, {
		label: t('cards.commonDetail.type'),
		content: card.cardTypeDescription || card.type
	}, {
		label: t('cards.commonDetail.situation'),
		content: card.unblockable ? t('cards.blockedStatus') : card.statusDescriptive
	}, {
		label: t('cards.commonDetail.expiryDate'),
		content: card.expiryDate ? getMonthYear(card.expiryDate) : '** ****'
	}]
}
